import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Tell us about your school",
    body: "Size, goals, printing volume—just the basics.",
  },
  {
    n: "02",
    title: "We recommend the right bundle",
    body: "We match printer size, supply length, and finishing tools.",
  },
  {
    n: "03",
    title: "You receive a clear quote",
    body: "One itemized quote—no stitching together vendors.",
  },
  {
    n: "04",
    title: "You're fully set up",
    body: "Approve and we handle the rest—delivery, setup, and support.",
  },
];

export default function BundlesProcess() {
  return (
    <section
      id="bundles-process"
      data-testid="bundles-process-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Process
          </div>
          <h2
            data-testid="bundles-process-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`bundles-process-step-${i}`}
              className="group relative bg-[#F4F6F4] hover:bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-7 transition-all duration-300 hover:shadow-lg flex flex-col"
            >
              <div className="flex items-baseline gap-3 mb-5">
                <span className="font-serif text-4xl font-black text-teal leading-none">
                  {s.n}
                </span>
                <span className="h-px flex-1 bg-slate-200 group-hover:bg-teal/40 transition-colors" />
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-navy mb-3 leading-tight">
                {s.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
